<template>
  <div class="flex-row align-items-center justify-content-between gap-sm">
    <DdAvatarAndName
        :name="customerName"
        :customer-id="customer.id"/>
    <div class="insurance-count-badge">
      <span>{{ insuranceCount }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomerTab",
  props: {
    customer: {
      type: Object,
      required: true,
    },
  },
  computed: {
    customerName() {
      return this.customer?.full_name || '';
    },
    insuranceCount() {
      return this.customer?.object_count?.data?.insurance_count || 0;
    },
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.insurance-count-badge {
  background-color: $brand-primary;
  color: white;
  font-size: $font-size-small;
  padding: 0 $spacing-xxs;
  border-radius: $spacing-lg;
  height: $spacing-lg;
  min-width: $spacing-lg;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  span{
    margin-top: 2px;
  }
}
</style>
